import * as Request from '../Request';
const IconLibrary = {
  // 新增
  save: (data) => {
    return Request.post('/fxWarnSign/save', data)
  },
  // 编辑
  update: (data) => {
    return Request.put('/fxWarnSign/update', data)
  },
  // 删除
  del: (data) => {
    return Request.del('/fxWarnSign/delete', data)
  },
  // 列表
  list: (data) => {
    return Request.post('/fxWarnSign/list', data)
  },
  // 类型
  type: (data) => {
    return Request.get('/fxWarnSign/sign/type', data)
  }
}
export default IconLibrary
